import React from "react";
import Particles from "../../Particles/Particles";
import HeroSection from "./HeroSection";
import "./chemical.css";
import KeyChallenges from "./KeyChallenges";
import KeyFeatures from "./KeyFeatures";
import HowItWorks from "./HowItWorks";
import TechnologyStack from "./TechnologyStack";
import CallToAction from "./CallToAction";
import Benefits from "./Benefits";

const Chemical = () => {
  return (
    <div className="chemical-industry-wrapper">
      <Particles title="chemical" />
      <HeroSection />
      <KeyChallenges />
      <KeyFeatures />
      <Benefits />
      <HowItWorks />
      <TechnologyStack />
      <CallToAction />
    </div>
  );
};

export default Chemical;
